import { useEffect, useState } from "react";
import SectionLabel from "@/components/SectionLabel";
import { api } from "@/lib/api";
import { X } from "lucide-react";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState(null);
  useEffect(() => { api.get("/gallery").then(r => setItems(r.data)).catch(()=>{}); }, []);

  return (
    <div>
      <section className="py-16 lg:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <SectionLabel>Gallery</SectionLabel>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900">Inside Aarogya Clinic</h1>
          <p className="mt-3 text-slate-600 max-w-2xl">A calm, clean and well-equipped space designed for your comfort.</p>

          <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {items.map((g, i) => (
              <button key={g.id} onClick={() => setActive(g)}
                      className="group rounded-2xl overflow-hidden aarogya-shadow border border-slate-200/70 bg-white"
                      data-testid={`gallery-item-${i}`}>
                <div className="aspect-[4/3] overflow-hidden">
                  <img src={g.image_url} alt={g.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-500" />
                </div>
                <div className="px-4 py-3 text-left">
                  <div className="text-[10px] uppercase tracking-[0.22em] text-teal-600 font-semibold">{g.category}</div>
                  <div className="text-sm font-semibold text-slate-800 mt-1">{g.title}</div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div className="fixed inset-0 z-[70] bg-black/80 backdrop-blur flex items-center justify-center p-4"
             onClick={() => setActive(null)} data-testid="lightbox">
          <button className="absolute top-4 right-4 h-10 w-10 rounded-full bg-white/20 text-white grid place-items-center"
                  onClick={() => setActive(null)} aria-label="Close">
            <X />
          </button>
          <img src={active.image_url} alt={active.title} className="max-h-[90vh] max-w-[95vw] rounded-2xl" />
        </div>
      )}
    </div>
  );
}
